/**
 * Microsoft Copilot Studio integration (Direct Line Web Chat).
 */
import { axiosInstance } from '@services/api/axios.instance';

export interface CopilotStudioConfig {
  enabled: boolean;
  configured: boolean;
  directline_domain: string;
}

export interface CopilotHistoryMessage {
  id: string;
  role: string;
  content: string;
  activity_id?: string | null;
  created_at: string;
}

export interface CopilotDirectLineToken {
  token: string;
  conversation_id: string;
  expires_in: number;
  directline_domain: string;
  stream_url?: string | null;
  reconnected?: boolean;
  history_messages?: CopilotHistoryMessage[];
}

export interface CopilotMessageSaveRequest {
  conversation_id: string;
  role: 'user' | 'assistant';
  content: string;
  activity_id: string;
}

export interface CopilotMessageSaveResponse {
  saved: boolean;
  session_id: string;
  message_id?: string | null;
}

class CopilotService {
  async getConfig(): Promise<CopilotStudioConfig> {
    const response = await axiosInstance.get<CopilotStudioConfig>('/api/v1/chat/copilot/config');
    return response.data;
  }

  async getDirectLineToken(newChat = false): Promise<CopilotDirectLineToken> {
    const response = await axiosInstance.post<CopilotDirectLineToken>(
      '/api/v1/chat/copilot/directline/token',
      null,
      { params: newChat ? { new_chat: true } : undefined }
    );
    return response.data;
  }

  async saveMessage(payload: CopilotMessageSaveRequest): Promise<CopilotMessageSaveResponse> {
    const response = await axiosInstance.post<CopilotMessageSaveResponse>(
      '/api/v1/chat/copilot/sessions/messages',
      payload
    );
    return response.data;
  }
}

export const copilotService = new CopilotService();
export default copilotService;
